class FilterWidget extends BaseWidget<FilterResultVM, FilterConfig> {
    override widgetType = WidgetType.Filter;

    private updatingCondition: boolean = false;
    private updatingEditorType: boolean = false;
    private updatingBoundField: boolean = false;
    private updatingPropertyValue: boolean = false;

    constructor(container: any, tab: WorkbookTab, $reportContent, dashboardWidget: DashboardWidget) {
        super(container, tab, $reportContent, dashboardWidget);

        this.disableDrilldown = true;
    }

    setConfig(config) {
        this.itemConfig = new FilterConfig(config);
    }

    setResult(result) {
        let self = this;
        this.itemConfig.allValuesSelected(false);
        this.result = new FilterResultVM(result);
        this.result.filter.customPublish = function () {
            self.result.filter.isDirty(true);

            if (self.itemConfig.editorType() === FilterWidgetEditorTypeEnum.DateRange || self.itemConfig.editorType() === FilterWidgetEditorTypeEnum.Date) {
                self.itemConfig.values.dates.startDate(self.result.filter.startCondition());

                if (self.itemConfig.editorType() === FilterWidgetEditorTypeEnum.DateRange) {
                    self.itemConfig.values.dates.endDate(self.result.filter.endCondition());
                }

                self.itemConfig.values.dates.typeDateRange(self.result.filter.dateRange());

                self.itemConfig.values.dates.dateRangeConfig.userDates(self.result.filter.dateRangeConfig.userDates());
                self.itemConfig.values.dates.dateRangeConfig.lastDateUsed(self.result.filter.dateRangeConfig.lastDateUsed());
                self.itemConfig.values.dates.dateRangeConfig.startDate(self.result.filter.dateRangeConfig.startDate());
                self.itemConfig.values.dates.dateRangeConfig.endDate(self.result.filter.dateRangeConfig.endDate());
                self.itemConfig.values.dates.dateRangeConfig.multiplier(self.result.filter.dateRangeConfig.multiplier());
            }
            else if (self.itemConfig.editorType() === FilterWidgetEditorTypeEnum.List) {
                self.updateSelectedText();

                let multiSelectGrid = $(".multiSelect-filter-comp", self.$reportContent).dxDataGrid("instance");
                let keys = multiSelectGrid.option("selectedRowKeys");
                self.itemConfig.values.listValues(keys.slice());
            }

            if (self.itemConfig.condition() === FilterWidgetConditionEnum.MultipleSelection && self.result.dataTable && self.itemConfig.values.listValues().length
                && self.itemConfig.values.listValues().length === self.result.dataTable.length) {
                self.itemConfig.allValuesSelected(true);
            }
            else {
                self.itemConfig.allValuesSelected(false);
            }

            self.publishValues(true, true, false);
        };
        this.result.filter.showNullButton(this.itemConfig.showNullButton());
        this.result.filter.onContentReady = function () {
            self.updateSelectedText();
            self.updateValuesStyle();
        }

        //Override function
        this.result.filter.beforeApplyFilter = function () { }

        let selectedValues = this.itemConfig.values.listValues();
        let newSelectedValues = [];

        if (selectedValues.length > 0 && this.result.dataTable?.length > 0) {
            let fieldName = Object.keys(this.result.dataTable[0])[0];
            if (fieldName) {
                if (FilterService.hasNullEntries(selectedValues) && !this.result.dataTable.find(x => x[fieldName] === null)) {
                    this.result.dataTable = [[null, irSettings.nullText as any] as any, ...this.result.dataTable];
                }

                for (let x of selectedValues) {
                    if (this.result.dataTable.find(function (f) { return f[fieldName] == x })) {
                        newSelectedValues.push(x);
                    }
                }
            }

            if (newSelectedValues.length > 1 && this.result.dataTable.length > 0) {
                if (newSelectedValues.length === this.result.dataTable.length) {
                    this.result.valuesSelectedTitleText("All");
                }
                else {
                    this.result.valuesSelectedTitleText(`${newSelectedValues.length}/${this.result.dataTable.length}`);
                }
            }
            else {
                this.result.valuesSelectedTitleText("");
            }

            if (this.itemConfig.condition() === FilterWidgetConditionEnum.SingleSelection &&
                (this.itemConfig.editorType() === FilterWidgetEditorTypeEnum.DropDown || this.itemConfig.editorType() === FilterWidgetEditorTypeEnum.List)) {
                this.result.filter.multipleCondition(selectedValues);
            }
        }

        this.result.filter.dataSource(this.result.dataTable);
        if (!this.compareArrays(this.itemConfig.values.listValues(), newSelectedValues)) {
            this.itemConfig.values.listValues(newSelectedValues);
        }

        this.setComponentAlignment();
        this.updateValuesStyle();
    }


    setupSettings() {
        let self = this;        
        let refreshValuesStyle = function () {
            self.updateValuesStyle();
        }
        this.createSettingItem(this.itemConfig.valuesTextConfig.fontSize, "valuesTextConfig.fontSize", UpdateSettingMode.Custom, refreshValuesStyle);
        this.createSettingItem(this.itemConfig.valuesTextConfig.fontColor, "valuesTextConfig.fontColor", UpdateSettingMode.Custom, refreshValuesStyle);
        this.createSettingItem(this.itemConfig.valuesTextConfig.fontBold, "valuesTextConfig.fontBold", UpdateSettingMode.Custom, refreshValuesStyle);
        this.createSettingItem(this.itemConfig.valuesTextConfig.fontItalic, "valuesTextConfig.fontItalic", UpdateSettingMode.Custom, refreshValuesStyle);

        this.createSettingItem(this.itemConfig.titleTextConfig.fontSize, "titleTextConfig.fontSize", UpdateSettingMode.Custom, () => {
            self.calculateHeightFilter();
        });
        this.createSettingItem(this.itemConfig.titleTextConfig.fontColor, "titleTextConfig.fontColor", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.fontBold, "titleTextConfig.fontBold", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.fontItalic, "titleTextConfig.fontItalic", UpdateSettingMode.Automatic);

        this.createSettingItem(this.itemConfig.values.listValues, "values.listValues", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.values.dates.startDate, "values.dates.startDate", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.values.dates.endDate, "values.dates.endDate", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.values.dates.typeDateRange, "values.dates.typeDateRange", UpdateSettingMode.Automatic);

        this.createSettingItem(this.itemConfig.applyCondition, "applyCondition", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.showNullButton, "showNullButton", UpdateSettingMode.Reload);
        
        this.createSettingItem(this.itemConfig.titleText, "titleText", UpdateSettingMode.Custom, () => {
            self.calculateHeightFilter();
        });

        this.createSettingItem(this.itemConfig.dynamicParameter, "dynamicParameter", UpdateSettingMode.Automatic);
        //this.createSettingItem(this.itemConfig.dynamicParameterName, "dynamicParameterName", UpdateSettingMode.Automatic);
        this.itemConfig.dynamicParameterName.subscribe(function () {
            if (!self.updatingPropertyValue) {
                self.saveSettings();
            }
        });

        this.itemConfig.metricField.subscribe(function () {
            if (!self.updatingPropertyValue) {
                self.saveSettings(function () {
                    self.tabOrWidget.refresh();
                });
            }
        });
        
        //this.createSettingItem(this.itemConfig.conditionType, "conditionType", UpdateSettingMode.Custom, function () {
        //    if (!self.updatingCondition && !self.updatingEditorType && !self.updatingBoundField) {
        //        self.publishValues(false, false);
        //    }
        //});
        this.itemConfig.conditionType.subscribe(function () {
            if (!self.updatingPropertyValue) {
                self.saveSettings(function () {
                    self.publishValues(false, false);
                });
            }
        });

        this.createSettingItem(this.itemConfig.scopeAction, "scopeAction", UpdateSettingMode.Custom, function () {
            self.publishValues(false, false);
        });
        this.itemConfig.condition.subscribe(function () {
            let resetProperty = self.updatingPropertyValue === false;

            self.updatingPropertyValue = true;
            let values = self.itemConfig.values.listValues();
            if (self.itemConfig.condition() === FilterWidgetConditionEnum.SingleSelection) {
                if (Array.isArray(values)) {
                    if (values.length > 1) {
                        self.itemConfig.values.listValues(values.slice(0, 1));
                    }
                }
                else {
                    self.itemConfig.values.listValues(null);
                }

                if (self.itemConfig.conditionType() !== FilterConditionTypeEnum.Equals && self.itemConfig.conditionType() !== FilterConditionTypeEnum.Different) {
                    if (self.itemConfig.conditionType() === FilterConditionTypeEnum.NotIn) {
                        self.itemConfig.conditionType(FilterConditionTypeEnum.Different);
                    }
                    else {
                        self.itemConfig.conditionType(FilterConditionTypeEnum.Equals);
                    }
                }
            }
            else if (self.itemConfig.condition() === FilterWidgetConditionEnum.MultipleSelection) {
                if (!Array.isArray(values)) {
                    self.itemConfig.values.listValues([values]);
                }

                if (self.itemConfig.conditionType() !== FilterConditionTypeEnum.In && self.itemConfig.conditionType() !== FilterConditionTypeEnum.NotIn) {
                    if (self.itemConfig.conditionType() === FilterConditionTypeEnum.Different) {
                        self.itemConfig.conditionType(FilterConditionTypeEnum.NotIn);
                    }
                    else {
                        self.itemConfig.conditionType(FilterConditionTypeEnum.In);
                    }
                }
            }
            else {
                if (self.itemConfig.conditionType() !== FilterConditionTypeEnum.Between) {
                    self.itemConfig.conditionType(FilterConditionTypeEnum.Between);
                }
            }

            if (resetProperty)
                self.updatingPropertyValue = false;

            if (!self.updatingPropertyValue) {
                self.publishValues(true, false);
                self.tabOrWidget.refresh();
            }
        });
        this.itemConfig.editorType.subscribe(function () {
            self.setComponentAlignment();

            let resetProperty = self.updatingPropertyValue === false;
            self.updatingPropertyValue = true;
            if (self.itemConfig.editorType() === FilterWidgetEditorTypeEnum.DateRange) {
                self.itemConfig.metricField(null);
                self.itemConfig.displayField(null);

                self.itemConfig.condition(FilterWidgetConditionEnum.Between);
                self.itemConfig.conditionType(FilterConditionTypeEnum.Between);
            }
            else if (self.itemConfig.editorType() === FilterWidgetEditorTypeEnum.Date) {
                self.itemConfig.metricField(null);
                self.itemConfig.displayField(null);

                self.itemConfig.condition(FilterWidgetConditionEnum.SingleSelection);
                self.itemConfig.conditionType(FilterConditionTypeEnum.Equals);
            }
            else {
                if (self.itemConfig.condition() === FilterWidgetConditionEnum.Between) {
                    self.itemConfig.condition(FilterWidgetConditionEnum.MultipleSelection);
                    self.itemConfig.conditionType(FilterConditionTypeEnum.In);
                }
            }

            self.updateFilterValuesToDefault(self.itemConfig.editorType());
            self.updateValuesStyle();

            if (resetProperty)
                self.updatingPropertyValue = false;

            if (!self.updatingPropertyValue) {
                self.saveSettings(function () {
                    self.tabOrWidget.refresh();
                });
            }
        });
    }

    repaint() {
        
    }

    runSetup() {
        
    }

    setup() {
        this.setComponentAlignment();
        this.updateValuesStyle();
    }

    updateBoundField(newValue: FieldNameInputModel, oldValue: FieldNameInputModel, save: boolean = true, removeMappingFilter: boolean = true) {
        let resetProperty = this.updatingPropertyValue === false;
        this.updatingPropertyValue = true;
        this.itemConfig.boundField(newValue.fieldId);

        if (newValue.type === DataTypeEnum.DATE) {
            if (this.itemConfig.editorType() !== FilterWidgetEditorTypeEnum.Date && this.itemConfig.editorType() !== FilterWidgetEditorTypeEnum.DateRange) {
                this.updateFilterValuesToDefault(FilterWidgetEditorTypeEnum.DateRange);
                this.itemConfig.editorType(FilterWidgetEditorTypeEnum.DateRange)
            }
        }
        else {
            if (this.itemConfig.editorType() === FilterWidgetEditorTypeEnum.DateRange || this.itemConfig.editorType() === FilterWidgetEditorTypeEnum.Date) {
                this.itemConfig.editorType(FilterWidgetEditorTypeEnum.DropDown)
            }
        }

        if (!this.itemConfig.titleText() || (!oldValue || this.itemConfig.titleText() === replaceBasicHtmlContent(oldValue.displayName))) {
            this.itemConfig.titleText(replaceBasicHtmlContent(newValue.displayName));
        }

        if (!this.itemConfig.dynamicParameterName() || (!oldValue || this.itemConfig.dynamicParameterName() === replaceBasicHtmlContent(oldValue.nodeName))) {
            this.itemConfig.dynamicParameterName(replaceBasicHtmlContent(newValue.nodeName));
        }

        if (removeMappingFilter) {
            this.itemConfig.mappingFilter(null);
        }

        if (resetProperty)
            this.updatingPropertyValue = false;

        if (save) {
            let self = this;
            this.saveSettings(function () {
                self.tabOrWidget.refresh();
            });
        }
    }

    updateFilterValuesToDefault(editorType: FilterWidgetEditorTypeEnum) {
        let self = this;
        if (this.result?.filter) {
            switch (editorType) {
                case FilterWidgetEditorTypeEnum.Date:
                    this.result.filter.filterEditorType(FilterEditorTypeEnum.Date);
                    this.itemConfig.values.dates.endDate(null);
                    this.result.filter.endCondition(null);
                    break;
                case FilterWidgetEditorTypeEnum.DateRange:
                    this.result.filter.filterEditorType(FilterEditorTypeEnum.DateRange);
                    if (!this.itemConfig.values.dates.endDate()) {
                        if (this.itemConfig.values.dates.typeDateRange() !== irGlobal.customDate.custom && this.itemConfig.values.dates.typeDateRange() !== irGlobal.customDate.none) {
                            let functionDate = DateRangeService.DatesRange.find(function (x) { return x.id() === self.itemConfig.values.dates.typeDateRange(); });
                            if (functionDate) {
                                this.itemConfig.values.dates.endDate(`${functionDate.endDate()}T00:00:00`);
                            }
                            else {
                                this.itemConfig.values.dates.endDate(this.itemConfig.values.dates.startDate());
                            }
                        }
                        else {
                            this.itemConfig.values.dates.endDate(this.itemConfig.values.dates.startDate());
                        }

                        this.result.filter.endCondition(this.itemConfig.values.dates.endDate());
                    }
                    break;
                case FilterWidgetEditorTypeEnum.DropDown:
                    break;
                case FilterWidgetEditorTypeEnum.List:
                    break;
                default:
                    break;
            }
        }
    }

    private updateSelectedText(element: JQuery<HTMLElement> = null) {
        element ??= this.$reportContent;
        if (this.itemConfig.editorType() === FilterWidgetEditorTypeEnum.List) {
            let multiSelectGrid = $(".multiSelect-filter-comp", element).dxDataGrid("instance");
            let dataSource = multiSelectGrid.option("dataSource") as any;
            let keys = multiSelectGrid.option("selectedRowKeys");
            if (keys && keys.length > 1 && dataSource.length > 0) {
                if (keys.length === dataSource.length) {
                    this.result.valuesSelectedTitleText("All");
                }
                else {
                    this.result.valuesSelectedTitleText(`${keys.length}/${dataSource.length}`);
                }
            }
            else {
                this.result.valuesSelectedTitleText("");
            }
        }
    }

    private updateValuesStyle() {
        let element = this.$reportContent;
        switch (this.itemConfig.editorType()) {
            case FilterWidgetEditorTypeEnum.DropDown:
                $("input[type='text']", $("#filterWidgetDropDown", element)).css({
                    'font-size': this.itemConfig.valuesTextConfig.fontSize() + 'px',
                    'color': this.itemConfig.valuesTextConfig.fontColor(),
                    'font-weight': this.itemConfig.valuesTextConfig.fontBold() ? 'bold' : 'normal',
                    'font-style': this.itemConfig.valuesTextConfig.fontItalic() ? 'italic' : 'normal',
                });
                break;
            case FilterWidgetEditorTypeEnum.Date:
                $(".dx-datebox", element).css({
                    'width': this.itemConfig.valuesTextConfig.fontSize() * 65 / 12
                });

                $("input[type='text']", $(".dx-datebox", element)).css({
                    'font-size': this.itemConfig.valuesTextConfig.fontSize() + 'px',
                    'color': this.itemConfig.valuesTextConfig.fontColor(),
                    'font-weight': this.itemConfig.valuesTextConfig.fontBold() ? 'bold' : 'normal',
                    'font-style': this.itemConfig.valuesTextConfig.fontItalic() ? 'italic' : 'normal',
                });

                $(".dx-lookup", $("date-range-types", element)).css({
                    'font-size': this.itemConfig.valuesTextConfig.fontSize() + 'px',
                    'color': this.itemConfig.valuesTextConfig.fontColor(),
                    'font-weight': this.itemConfig.valuesTextConfig.fontBold() ? 'bold' : 'normal',
                    'font-style': this.itemConfig.valuesTextConfig.fontItalic() ? 'italic' : 'normal',
                    'width': this.itemConfig.valuesTextConfig.fontSize() * 82 / 12
                });
                break;
            case FilterWidgetEditorTypeEnum.DateRange:
                $(".dx-daterangebox", element).css({
                    'width': this.itemConfig.valuesTextConfig.fontSize() * 140 / 12
                });

                $("input[type='text']", $(".dx-daterangebox", element)).css({
                    'font-size': this.itemConfig.valuesTextConfig.fontSize() + 'px',
                    'color': this.itemConfig.valuesTextConfig.fontColor(),
                    'font-weight': this.itemConfig.valuesTextConfig.fontBold() ? 'bold' : 'normal',
                    'font-style': this.itemConfig.valuesTextConfig.fontItalic() ? 'italic' : 'normal',
                });

                $(".dx-lookup", $("date-range-types", element)).css({
                    'font-size': this.itemConfig.valuesTextConfig.fontSize() + 'px',
                    'color': this.itemConfig.valuesTextConfig.fontColor(),
                    'font-weight': this.itemConfig.valuesTextConfig.fontBold() ? 'bold' : 'normal',
                    'font-style': this.itemConfig.valuesTextConfig.fontItalic() ? 'italic' : 'normal',
                    'width': this.itemConfig.valuesTextConfig.fontSize() * 82 / 12
                });
                break;
            case FilterWidgetEditorTypeEnum.List:
                $("span:not(.glyphicon, .dx-checkbox-icon)", $(".multiSelect-filter-comp", element)).css({
                    'font-size': this.itemConfig.valuesTextConfig.fontSize() + 'px',
                    'color': this.itemConfig.valuesTextConfig.fontColor(),
                    'font-weight': this.itemConfig.valuesTextConfig.fontBold() ? 'bold' : 'normal',
                    'font-style': this.itemConfig.valuesTextConfig.fontItalic() ? 'italic' : 'normal'
                })
                $("span.glyphicon", $(".multiSelect-filter-comp", element)).css({
                    /*'font-size': this.itemConfig.valuesTextConfig.fontSize() + 'px',*/
                    'color': this.itemConfig.valuesTextConfig.fontColor(),
                    //'font-weight': this.itemConfig.valuesTextConfig.fontBold() ? 'bold' : 'normal',
                    //'font-style': this.itemConfig.valuesTextConfig.fontItalic() ? 'italic' : 'normal'
                })
                break;
            default:
        }
    }

    private idTimeoutPublish: any;
    publishValues(saveConfig: boolean = true, useDelayMultipleSelection: boolean = true, refreshWidget: boolean = true) {
        let self = this;
        let publish = function () {
            let update = function () {
                self.result.filter.isDirty(true);
                //if (self.itemConfig.condition() === FilterWidgetConditionEnum.MultipleSelection) {
                //    if (self.result.filter.dataSource() && self.result.filter.dataSource().length && self.result.filter.multipleCondition() &&
                //        self.result.filter.dataSource().length === self.result.filter.multipleCondition().length) {
                //        self.result.filter.multipleCondition([]);
                //    }
                //}

                if (self.itemConfig.applyCondition() === FilterWidgetApplyConditionEnum.Manually) {
                    workbook.workbookConfig.workbookHelper.applyFiltersDisabled(false);
                }
                else if (self.itemConfig.applyCondition() === FilterWidgetApplyConditionEnum.Automatic) {;
                    for (let dashboardWidget of self.tab.dashboard.widgets()) {
                        if (dashboardWidget.id() !== self.dashboardWidget.id()) {
                            dashboardWidget.refresh();
                        }
                    }
                }
            };

            if (saveConfig) {
                self.saveSettings(update);
            }
            else {
                update();
            }
        };

        if (self.itemConfig.condition() === FilterWidgetConditionEnum.MultipleSelection && useDelayMultipleSelection) {
            clearTimeout(self.idTimeoutPublish);
            self.idTimeoutPublish = setTimeout(function () {
                publish();
            }, 750);
        }
        else {
            publish();
        }
    }

    compareArrays(array1 = [], array2 = []) {
        return JSON.stringify(array1) === JSON.stringify(array2);
    }

    calculateHeightFilter() {
        let div = $(".editorType", this.$reportContent);;
        let label = $(".widget-container-filter-name", this.$reportContent);
        let height = Math.max(16, label.height());
        div.css("height", `calc(100% - ${(height + 3)}px)`);
    }

    setComponentAlignment() {
        if (this.$reportContent) {
            this.$reportContent.parent(".resultsTableContainer").css({
                display: this.itemConfig.editorType() === FilterWidgetEditorTypeEnum.List ? "block" : "flex",
                "align-items": "center",
                "justify-content": "center"
            });
        }
    }
}